import { get } from './http';

const vipUrl = process.env.VUE_APP_VIP_URL;
const baseUrl = process.env.VUE_APP_BASE_URL;

// 获取 vip 状态
const getVipInfo = () => get(`${vipUrl}/user/status`);
// 获取 AIPPT vip 状态
const getSlideVipInfo = () => get(`${vipUrl}/user/extra/status`);
// 用户剩余次数
const getUserRemain = () => get(`${baseUrl}/userRight/remain`);

export default {
  getVipInfo,
  getSlideVipInfo,
  getUserRemain,
}
